import { findRegimen, type Regimen } from "@/data/meal-plan";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface RegimenSelectorProps {
  value: Regimen["id"] | null;
  onChange: (regimenId: Regimen["id"] | null) => void;
  /** The current plan's regimens */
  regimens: Regimen[];
}

export function RegimenSelector({ value, onChange, regimens }: RegimenSelectorProps) {
  const selected = findRegimen(value);
  // A day keeps its regimen after the user switches plans: list it too so the
  // select isn't blank.
  const options =
    selected && !regimens.some((r) => r.id === selected.id)
      ? [...regimens, selected]
      : regimens;

  return (
    <div className="space-y-1">
      <label className="text-sm font-medium">Tipo de día</label>
      <Select
        value={value ?? undefined}
        onValueChange={(v) => onChange(v as Regimen["id"])}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Selecciona un régimen..." />
        </SelectTrigger>
        <SelectContent>
          {options.map((r) => (
            <SelectItem key={r.id} value={r.id}>
              {r.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selected && (
        <p className="text-xs text-muted-foreground">
          {selected.description}
          {selected.trainingTime && ` — Entrenamiento: ${selected.trainingTime}`}
        </p>
      )}
      {selected?.notes && selected.notes.length > 0 && (
        <ul className="text-xs text-muted-foreground list-disc pl-4 space-y-0.5">
          {selected.notes.map((n) => (
            <li key={n}>{n}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
